import { render, staticRenderFns } from "./comment_body.vue?vue&type=template&id=0ce56efe&scoped=true&"
import script from "./comment_body.vue?vue&type=script&lang=js&"
export * from "./comment_body.vue?vue&type=script&lang=js&"
import style0 from "./comment_body.vue?vue&type=style&index=0&id=0ce56efe&scoped=true&lang=css&"
import style1 from "./comment_body.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce56efe",
  null
  
)

export default component.exports